export default __webpack_public_path__ + "static/media/Ring of Intent.908bccac.jpg";